import { FireAndFlowerOldStyleCardStack } from './fire-and-flower-old-style-card-stack';
import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { FireAndFlowerSaleCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/custom-cards-2x2/fire-and-flower-sale-card-stack-background/fire-and-flower-sale-card-stack-background.component';
import { FireAndFlowerSaleCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/custom-cards-2x2/fire-and-flower-sale-card-stack-content/fire-and-flower-sale-card-stack-content.component';

export class FireAndFlowerSaleCardStack extends FireAndFlowerOldStyleCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return FireAndFlowerSaleCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return FireAndFlowerSaleCardStackContentComponent;
  }
}
